import { useState, useEffect } from 'react';
import { DAV_APIS } from '../adapters';
import { StaffUserProps } from '../constants';

let staffCache: StaffUserProps[] = [];

const useStaffUsers = (refresh?: number | null) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [staffUsers, setStaffUsers] = useState<StaffUserProps[]>([]);

  useEffect(() => {
    const fetchStaff = async () => {
      if (!navigator.onLine) return;
      if (staffCache.length > 0 && !refresh) {
        setStaffUsers(staffCache);
        return;
      }
      setLoading(true);
      try {
        const res = await DAV_APIS.agents.getAllStaffUsers();
        setStaffUsers(res.data.staff);
        staffCache = res.data.staff;
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchStaff();
  }, [refresh]);

  return { loading, staffUsers };
};

export default useStaffUsers;
